"use client";

import  FaLocationArrow  from '@mui/icons-material/PinDrop';
import { projects } from "../data/index";
import { PinContainer } from "../ui/Pin";
import "./recent.css"; // Link to the CSS file
import testin from "../imgz/bitcoin pc done.png"

const RecentProjects = ({projectRef}) => {
  return (
    <div id="projects"  className="recent-projects-container">
      <h1 className="recent-projects-heading" ref={projectRef} >
        A small selection of{" "}
        <span className="recent-projects-highlight">recent projects</span>
      </h1>
      <div className="recent-projects-grid">
        {projects.map((item) => (
          <div className="project-card" key={item.id}>
            <img src={item.img} alt='' className='cardimg' />
            <div className='testdiv' ></div>
            <PinContainer title={item.link} href={item.link}>
              <div className="project-image-wrapper">
                <div className="project-image-background">
                  <img src="../svgs/bg.png" alt="Background" />  
                </div>
                {item.id > 4 ? (
                  <img
                    alt="Project"
                    src={item.img}
                    className="project-image"
                  />
                ) : (
                  <img
                    src={item.img}
                    alt="Cover"
                    className="project-image-cover"
                  />
                )}
              </div>

              <h1 className="project-title">{item.title}</h1>

              <p className="project-description">{item.des}</p>

              <div className="project-footer">
                <div className="project-icons">
                  {item.iconLists.map((icon, index) => (
                    <div
                      key={index}
                      className="project-icon-container"
                      style={{
                        transform: `translateX(-${5 * index + 2}px)`,
                      }}
                    >
                      <img src={icon} alt="Project Icon" className="project-icon" />
                    </div>
                  ))}
                </div>

                <div className="project-link">
                  <p className="project-link-text">Check Live Site</p>
                  <FaLocationArrow className="project-link-icon" />
                </div>
              </div>
            </PinContainer>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentProjects;
